import MyBioPage from './myBioPage.component';

export default MyBioPage;